import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "../components/Logo";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

const inputCls =
  "w-full bg-[#0D0C0A] border border-[rgba(201,162,101,0.2)] rounded-xl px-4 py-4 text-center text-2xl tracking-[0.5em] text-[#FAF7F2] placeholder-[#3a342c] focus:outline-none focus:border-[#C9A265] transition-colors duration-300";

export default function AdminLogin() {
  const { user, loginWithCode } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await loginWithCode(code);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-[#0D0C0A]">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm bg-[#171512] border border-[rgba(201,162,101,0.25)] rounded-2xl p-10"
      >
        <div className="flex flex-col items-center mb-8">
          <Logo className="h-16 w-16" />
          <h1 className="mt-5 font-cinzel text-lg tracking-[0.3em] text-[#FAF7F2]">AREA RISERVATA</h1>
          <p className="mt-2 text-sm text-[#7A7267]">Inserisci il codice di accesso</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
          <input
            data-testid="admin-login-code-input"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            required
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="••••"
            className={inputCls}
          />
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-400 bg-red-950/40 border border-red-900/50 rounded-xl px-4 py-3 text-center">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full px-8 py-4 bg-[#C9A265] text-[#0D0C0A] text-xs uppercase tracking-[0.25em] font-semibold font-cinzel rounded-full hover:bg-[#E0B87A] transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Accesso in corso..." : "Entra"}
          </button>
        </form>
        <a href="/" data-testid="admin-login-back-link" className="mt-6 block text-center text-xs text-[#7A7267] hover:text-[#C9A265] transition-colors">
          ← Torna al sito
        </a>
      </motion.div>
    </div>
  );
}
